import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ConvertHelper } from './helpers';

@Pipe({ standalone: true, name: 'localeDate' })
export class LocaleDatePipe implements PipeTransform {
  constructor() {}
  transform(value: Date | string | number) {
    return value ? ConvertHelper.toLocaleFormattedDateString(value) : '';
  }
}

@Pipe({ standalone: true, name: 'fileSize' })
export class FileSizePipe implements PipeTransform {
  transform(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

    return `${size} ${sizes[i]}`;
  }
}

@Pipe({ name: 'url' })
export class UrlPipe implements PipeTransform {
  transform(value: string): string {
    if (!/^https?:\/\//i.test(value)) {
      return 'https://' + value;
    }

    return value;
  }
}

@Pipe({ name: 'base64Image' })
export class Base64ImagePipe implements PipeTransform {
  private static readonly prefix = 'data:image/png;base64,';

  transform(value: string) {
    return Base64ImagePipe.addPrefix(value);
  }

  static addPrefix(value: string) {
    if (!value) {
      return;
    }
    if (value.includes(Base64ImagePipe.prefix)) {
      return value;
    }
    return Base64ImagePipe.prefix + value;
  }
}

@Pipe({
  name: 'safeResourceUrl',
})
export class SafeResourceUrlPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}
  transform(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
